import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { BellIcon, CheckCircle2Icon, PlusIcon, SearchIcon } from 'lucide-react';
import { AddLeadModal } from './AddLeadModal';
export function TopBar() {
  const navigate = useNavigate();
  const [addOpen, setAddOpen] = useState(false);
  const [confirmation, setConfirmation] = useState<string | null>(null);
  useEffect(() => {
    if (!confirmation) return;
    const timer = window.setTimeout(() => setConfirmation(null), 4000);
    return () => window.clearTimeout(timer);
  }, [confirmation]);
  return <header className="relative flex items-center gap-4 border-b border-gray-200 bg-white px-4 py-2.5" data-id="element-236" data-mp="2h13ouklrrwkt">
      <div className="relative w-full max-w-md" data-id="element-237" data-mp="2c3bk2q010fz7">
        <SearchIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" aria-hidden="true" data-id="element-238" data-mp="39jhbrp5khy54" />
        <input type="search" placeholder="Search leads, phones, loans..." aria-label="Search leads, phones, loans" className="w-full rounded-lg border border-gray-200 bg-white py-2 pl-9 pr-14 text-[13px] text-ink placeholder:text-gray-400 focus:border-brand focus:outline-none focus:ring-2 focus:ring-brand/20" data-id="element-239" data-mp="34q62zih737ak" />
        <kbd className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 rounded border border-gray-200 bg-gray-50 px-1.5 py-0.5 text-[10px] font-medium text-gray-500" data-id="element-240" data-mp="3tiviwtdpskd7">
          ⌘K
        </kbd>
      </div>

      <div className="ml-auto flex items-center gap-2" data-id="element-241" data-mp="3jn0s3azc7izc">
        <button type="button" onClick={() => setAddOpen(true)} className="inline-flex items-center gap-1.5 rounded-lg border border-gray-200 bg-white px-3 py-1.5 text-[13px] font-medium text-ink transition-colors hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-brand/30" data-id="element-242" data-mp="35mq0u6u482dn">
          <PlusIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-243" data-mp="18sd5w3s4bhdz" />
          Add lead
        </button>
        <button type="button" aria-label="Notifications" className="relative rounded-lg border border-gray-200 bg-white p-2 text-gray-600 transition-colors hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-brand/30" data-id="element-244" data-mp="16fsrfhhgg05y">
          <BellIcon className="h-4 w-4" aria-hidden="true" data-id="element-245" data-mp="sfrq60xa2qpy" />
          <span className="absolute right-1.5 top-1.5 h-1.5 w-1.5 rounded-full bg-danger" data-id="element-246" data-mp="shcp02qmkvtm" />
        </button>
      </div>

      <AddLeadModal open={addOpen} onClose={() => setAddOpen(false)} onCreated={name => {
      setConfirmation(`${name} added to your leads`);
      navigate('/leads');
    }} data-id="element-247" data-mp="1l3xbaos8uhqb" />

      <AnimatePresence data-id="element-248" data-mp="1bevyt8kwqih3">
        {confirmation && <motion.div role="status" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} className="absolute right-4 top-full z-40 mt-2 inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-[12.5px] font-medium text-ink shadow-lg" data-id="element-249" data-mp="1bbzzbftevlqj">
            <CheckCircle2Icon className="h-4 w-4 text-success" aria-hidden="true" data-id="element-250" data-mp="2gdj2cklsrrj5" />
            {confirmation}
          </motion.div>}
      </AnimatePresence>
    </header>;
}